import { defineComponent as _defineComponent } from 'vue'
import useSuggestionBox from '@/mixins/useSuggestionBox';
import {
  computed, nextTick, onBeforeUnmount, onMounted, PropType, ref, toRefs, watch
} from 'vue';
import {
  onClickOutside, templateRef, useElementBounding, useRafFn, useVModel
} from '@vueuse/core';
import X from '@/components/svg-components/X.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXSuggestionBox',
  props: {
  placeholder: {
    type: String,
    default: ''
  },
  maxLength: {
    type: Number,
    default: 2000
  },
  list: {
    type: Array as PropType<any []>,
    default: () => []
  },
  value: {
    type: String,
    default: ''
  },
  autofocus: Boolean,
  clearable: Boolean,
  showAllWhenEmpty: Boolean,
  filterable: {
    type: Boolean,
    default: true
  },
  disabled: Boolean
},
  emits: ['select', 'clear'],
  setup(__props, { emit }) {

const props = __props;




const vv = ref(0);

const {
  list,
  autofocus,
  showAllWhenEmpty,
  filterable
} = toRefs(props);
const search = useVModel(props);
const input = templateRef<HTMLInputElement>('input');
const box = templateRef<HTMLElement>('suggestion-box');
const isFocused = ref(false);

const {
  left,
  width,
  bottom,
  update: updateBoundingBox
} = useElementBounding(box, {
  immediate: true
});

const onVisualViewport = () => {
  vv.value = window.visualViewport.offsetTop;
};

onMounted(() => {
  if (input.value && autofocus.value) {
    input.value.focus();
  }
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', onVisualViewport);
    window.visualViewport.addEventListener('scroll', onVisualViewport);
  }
});

onBeforeUnmount(() => {
  window.visualViewport.removeEventListener('resize', onVisualViewport);
  window.visualViewport.removeEventListener('scroll', onVisualViewport);
});

const { cursorPosition } = useSuggestionBox({
  input,
  list,
  select: (index) => {
    emit('select', list.value?.[index], index);
  }
});

const clear = () => {
  search.value = '';
  emit('clear');
};

const onInput = () => {
  isFocused.value = true;
};

const close = async () => {
  await nextTick();
  isFocused.value = false;
};

onClickOutside(input, async () => {
  isFocused.value = false;
  await close();
}, {
  ignore: ['.c-list-wrapper']
});

const isListShown = computed(() => {
  if (!isFocused.value) return false;
  return !!(showAllWhenEmpty.value || (!filterable.value && list.value.length) || (list.value.length && search.value));
});

const { resume, pause } = useRafFn(() => {
  updateBoundingBox();
}, { immediate: false });

watch(isListShown, (is) => {
  if (is) resume();
  else pause();
});

return { __sfc: true,props, emit, vv, list, autofocus, showAllWhenEmpty, filterable, search, input, box, isFocused, left, width, bottom, updateBoundingBox, onVisualViewport, cursorPosition, clear, onInput, close, isListShown, resume, pause, X }
}

})